import React from 'react';
import { URL } from 'utils/url-builder';
import { SectionPage } from 'components/ui/skeletons/section-page';
import { OfferList } from './offer-list';
import { OfferPage } from './offer-page';

export const OffersPage = () => {
  return <SectionPage sectionListUrl={URL.offerList()} listComponent={OfferList} pageComponent={OfferPage} />;
};
